import React from "react";

import { reportError } from "./errors";

/**
 * App-wide error boundary with ZERO error-monitoring dependency, so it is safe
 * to sit in the static client entry graph. Caught errors are forwarded to
 * whatever reporter has registered via `errors.ts` (Sentry, once it lazily
 * loads); if none has, the error is still contained and the fallback shown.
 */
type Props = { fallback: React.ReactNode; children: React.ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    reportError(error, info);
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
